import { useEffect, useState } from 'react';
import { Link as LinkClipf } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.css';
import { MenuListButtonProps } from '../../interfaces/props/MenuListButtonProps';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import LoadingApp from '../LoadingApp';
import ModalFeedBack from '../ModalFeedBack';
import { getMensagemRestricao } from '../../services/Home/HomeService';


function MenuListButton(props: MenuListButtonProps) {
  const [open, setOpen] = useState(false);
  const { to, children, icon, highlight, restricted, external, component } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>('');

  const { fontSizeStyleAccessibility } = useAccessibility();

  useEffect(() => {
    let pathName = location.pathname;
    if (pathName === to) {
      setOpen(true);
    }
    else {
      setOpen(false);
    }
  }, [location, to]);

  const handleRestrictedAccess = () => {
    setLoading(true);
    getMensagemRestricao(component)
      .then(response => {
        setModalText(response.data)
      })
      .catch(error => {
        console.log(error);
        setModalText('Acesso não permitido.')
      })
      .finally(() => {
        setLoading(false);
        setShowModal(true);
      })
  }

  const handleAccess = () => {
    if (!restricted) {
      navigate(to);
      props.handleMenu();
    } else {
      handleRestrictedAccess();
    }
  }

  if (external && !restricted) {
    return (
      <li>
        <LinkClipf tabIndex={-1} underline='none' className='text-decoration-none' onClick={() => window.open(to, '_blank')}>
          <button className="menu-list-button" style={fontSizeStyleAccessibility}>
            <FontAwesomeIcon icon={icon} />{' '}
            <span className={`${open ? 'bold' : 'normal'} ${highlight ? 'underline' : ''}`} style={fontSizeStyleAccessibility}>{children}</span>
          </button>
        </LinkClipf>
      </li>
    );
  }

  return (
    <li>
      <button tabIndex={0} className="menu-list-button" style={fontSizeStyleAccessibility} onClick={handleAccess}>
        <FontAwesomeIcon icon={icon} />{' '}
        <span className={`${open ? 'bold' : 'normal'} ${highlight ? 'underline' : ''}`} style={fontSizeStyleAccessibility}>{children}</span>
      </button>

      <LoadingApp showLoading={loading} />

			<ModalFeedBack
				showModal={showModal} 
				handleShowModal={() => setShowModal(false)}
				icon={'warning'}
				textButton={''} 
				title={'Acesso não permitido'}
				subTitle={modalText}
			/>
    </li>
  );
}

export default MenuListButton;
